var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9V11.25M9 6.75H9.0075M15.7529 9C15.7529 12.7279 12.7308 15.75 9.00293 15.75C7.47562 15.75 2.25347 15.75 2.25347 15.75C2.25347 15.75 3.42287 12.9421 2.95486 12.0006C2.50557 11.0967 2.25293 10.0779 2.25293 9C2.25293 5.27208 5.275 2.25 9.00293 2.25C12.7308 2.25 15.7529 5.27208 15.7529 9Z",
    stroke: "#152B35",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.e8172e96d36dcefd6a8864eab58a41a7.svg";
export { ForwardRef as ReactComponent };